(function () {
  'use strict';

  var form = document.getElementById('ot-request-form');
  if (!form) return;

  var statusEl = document.getElementById('ot-request-status');
  var submitBtn = document.getElementById('ot-submit-btn');
  var loadedAtInput = document.getElementById('ot-form-loaded-at');

  // Record page load time for bot timing check
  if (loadedAtInput) {
    loadedAtInput.value = new Date().toISOString();
  }

  // Pill groups write their selection into hidden inputs so validation and
  // payload code read .value exactly as they would from a <select>.
  var pillGroups = form.querySelectorAll('[data-pills-for]');
  for (var g = 0; g < pillGroups.length; g++) {
    (function (group) {
      var input = document.getElementById(group.getAttribute('data-pills-for'));
      if (!input) return;
      group.addEventListener('click', function (ev) {
        var btn = ev.target.closest ? ev.target.closest('.ot-pill') : null;
        if (!btn || !group.contains(btn)) return;
        var wasPressed = btn.getAttribute('aria-pressed') === 'true';
        var pills = group.querySelectorAll('.ot-pill');
        for (var i = 0; i < pills.length; i++) {
          pills[i].setAttribute('aria-pressed', 'false');
        }
        if (wasPressed) {
          input.value = '';
        } else {
          btn.setAttribute('aria-pressed', 'true');
          input.value = btn.getAttribute('data-value') || '';
        }
      });
    })(pillGroups[g]);
  }

  // Read config from section settings (embedded as data attributes on form)
  var apiUrl = form.dataset.apiUrl || 'https://pro.asksamie.com/api/consumer-ot-request/submit';
  var turnstileSiteKey = form.dataset.turnstileSiteKey || '';
  var requestContext = form.dataset.requestContext || '';

  // Load Turnstile script if site key is configured
  var turnstileToken = '';
  if (turnstileSiteKey) {
    var script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = function () {
      if (window.turnstile) {
        window.turnstile.render('#ot-turnstile-container', {
          sitekey: turnstileSiteKey,
          size: 'flexible',
          callback: function (token) {
            turnstileToken = token;
          },
        });
      }
    };
    document.head.appendChild(script);
  }

  function showStatus(message, isError) {
    statusEl.textContent = message;
    statusEl.className = 'form-status ' + (isError ? 'form-status--error' : 'form-status--success');
    statusEl.style.display = 'block';
    statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Replace the form with a personalized success card. User values go in via
  // textContent only — never innerHTML.
  function showSuccess() {
    var first = form.querySelector('#ot-name').value.trim().split(/\s+/)[0] || 'friend';
    var email = form.querySelector('#ot-email').value.trim();
    var card = document.createElement('div');
    card.className = 'ot-success';
    var check = document.createElement('div');
    check.className = 'ot-success-check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    var heading = document.createElement('h2');
    heading.textContent = 'Request received, ' + first + '!';
    var body = document.createElement('p');
    body.textContent =
      'Our team personally reviews every request and will start reaching out to OTs in your area. ' +
      "We'll email you at " + email + ' with next steps.';
    card.appendChild(check);
    card.appendChild(heading);
    card.appendChild(body);
    form.parentNode.replaceChild(card, form);
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function validateForm() {
    var name = form.querySelector('#ot-name').value.trim();
    var email = form.querySelector('#ot-email').value.trim();
    var phone = form.querySelector('#ot-phone').value.trim();
    var state = form.querySelector('#ot-state').value;
    var city = form.querySelector('#ot-city').value.trim();
    var changes = form.querySelector('#ot-changes').value.trim();
    var problems = form.querySelector('#ot-problems').value.trim();

    if (!name) return 'Please enter your name.';
    if (name.length < 2) return 'Name must be at least 2 characters.';
    if (name.length > 100) return 'Name must be 100 characters or fewer.';
    if (!email) return 'Please enter your email address.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address.';
    if (!phone) return 'Please enter your phone number.';
    if (!state) return 'Please select your state.';
    if (!city) return 'Please enter your city.';
    var payment = form.querySelector('#ot-payment').value;
    var modality = form.querySelector('#ot-modality').value;
    if (!payment) return 'Please tell us how you plan to pay — "Not sure yet" is fine.';
    if (!modality) return 'Please tell us if in-person or virtual works for you.';
    if (!changes) return 'Please describe what changes have occurred.';
    if (changes.length < 10) return 'Please provide a bit more detail about what changes have occurred.';
    if (!problems) return 'Please describe what problems you want to solve.';
    if (problems.length < 10) return 'Please provide a bit more detail about the problems you want to solve.';

    if (turnstileSiteKey && !turnstileToken) {
      return 'Please complete the CAPTCHA verification.';
    }

    return null;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var error = validateForm();
    if (error) {
      showStatus(error, true);
      return;
    }

    // Gather form data — combine two questions into what_they_need
    var changes = form.querySelector('#ot-changes').value.trim();
    var problems = form.querySelector('#ot-problems').value.trim();
    var combinedNeeds = 'What changes have occurred:\n' + changes + '\n\nProblems to solve:\n' + problems;

    var payload = {
      name: form.querySelector('#ot-name').value.trim(),
      email: form.querySelector('#ot-email').value.trim(),
      phone: form.querySelector('#ot-phone').value.trim(),
      location_state: form.querySelector('#ot-state').value,
      location_city: form.querySelector('#ot-city').value.trim(),
      what_they_need: combinedNeeds,
      payment_method: form.querySelector('#ot-payment').value,
      modality_preference: form.querySelector('#ot-modality').value,
      turnstile_token: turnstileToken || 'not_configured',
    };

    // Optional fields
    var whoEl = form.querySelector('#ot-who');
    if (whoEl && whoEl.value) payload.who_its_for = whoEl.value;

    var urgencyEl = form.querySelector('#ot-urgency');
    if (urgencyEl && urgencyEl.value) payload.urgency = urgencyEl.value;

    var zipEl = form.querySelector('#ot-zip');
    if (zipEl && zipEl.value.trim()) payload.zip_code = zipEl.value.trim();

    // Honeypot
    var honeypotEl = form.querySelector('[name="company_url"]');
    if (honeypotEl && honeypotEl.value) payload.company_url = honeypotEl.value;

    // Timing
    if (loadedAtInput && loadedAtInput.value) payload.form_loaded_at = loadedAtInput.value;

    // Disable button during submission
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';
    statusEl.style.display = 'none';

    var headers = { 'Content-Type': 'application/json' };
    if (requestContext) headers['X-Request-Context'] = requestContext;

    fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.detail || 'Something went wrong. Please try again.');
          });
        }
        return response.json();
      })
      .then(function () {
        showSuccess();
      })
      .catch(function (err) {
        showStatus(err.message || 'Something went wrong. Please try again.', true);
        submitBtn.disabled = false;
        submitBtn.textContent = form.dataset.buttonLabel || 'Connect Me with an OT';

        // Reset Turnstile on error
        if (turnstileSiteKey && window.turnstile) {
          turnstileToken = '';
          window.turnstile.reset('#ot-turnstile-container');
        }
      });
  });
})();
